import React, { useState } from 'react'
import LightGrayBgWrapper from '../../../components/common/AffiliateCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper'
import styles from "./CommissionandPayout..module.scss"
import { Col, Row } from 'reactstrap'
import DynamicDatatable from '../../../components/common/AffiliateCommonComponents/DynamicDataTable/DynamicDataTable'
import ProfitView from '../../../components/common/AdminCommonComponents/Buttons/ActionButton/ProfitView'
import StatusBadge from '../../../components/common/AffiliateCommonComponents/StatusBadge/StatusBadge'
import TopTab from '../../../components/common/AffiliateCommonComponents/Commision&Payout/topTab'
import PaymentOptions from '../../../components/common/AffiliateCommonComponents/Commision&Payout/PaymentOptions'

function CommissionAndPayout() {
    const tableData = [
        {
            product: "Flowering Cactus",
            order: "$250",
            date: "29/02/2090",
            commission: "$41.75",
            payout: "$41.75",
            status: "pending"
        },
    ]

    const columns = [
        { name: 'Product', selector: (row) => row.product },
        { name: 'Order', selector: (row) => row.order },
        { name: 'Date', selector: (row) => row.date },
        { name: 'Commision', selector: (row) => row.commission },
        { name: 'Payout', selector: (row) => row.payout },
        { name: 'Status', selector: (row) => <StatusBadge statusName={row.status} /> },
    ]
    const [activeTab, setActiveTab] = useState("1")
    return (
        <LightGrayBgWrapper>
            <TopTab activeTab={activeTab} toggleTab={setActiveTab} />
            {activeTab === "1" &&
                <>
                    <Row className="g-3">
                        <Col xl={12} md={12}>
                            <Row className="g-3">
                                <Col className='d-grid' md={12} lg={4} sm={12}>
                                    <div className={styles.card}>
                                        <div className='d-flex justify-content-between'>
                                            <div className={styles.cardHeadingText}>Commission Rate</div>
                                            <div className={styles.smallText}>29/03/2024</div>
                                        </div>
                                        <div className={styles.cardText}>Vary with Product</div>
                                    </div>
                                </Col>
                                <Col className='d-grid' md={12} lg={4} sm={12}>
                                    <div className={styles.card}>
                                        <div className='d-flex justify-content-between'>
                                            <div className={styles.cardHeadingText}>Last Commission</div>
                                            <div className={styles.smallText}>29/03/2024</div>
                                        </div>
                                        <div className={styles.cardText}>$40</div>
                                    </div>
                                </Col>

                                <Col className='d-grid' md={12} lg={4} sm={12}>
                                    <div className={styles.card2}>
                                        <div className="d-flex justify-content-between">
                                            <div className={styles.cardText2}>Total Commission</div>
                                            <div className={styles.cardText4}>This Month</div>
                                        </div>
                                        <div className={styles.cardText3}>$1500</div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="g-3">
                                <Col className='d-grid' md={12} lg={4} sm={12}>
                                    <div className={styles.card}>
                                        <div className='d-flex justify-content-between'>
                                            <div className={styles.cardHeadingText}>Previous Payout</div>
                                            <div className={styles.smallText}>29/03/2024</div>
                                        </div>
                                        <div className={styles.cardText}>$1100</div>
                                    </div>
                                </Col>
                                <Col className='d-grid' md={12} lg={4} sm={12}>
                                    <div className={styles.card}>
                                        <div className='d-flex justify-content-between'>
                                            <div className={styles.cardHeadingText}>Next Payout</div>
                                            <div className={styles.smallText}>29/03/2024</div>
                                        </div>
                                        <div className={styles.cardText}>$4000</div>
                                    </div>
                                </Col>

                                <Col className='d-grid' md={12} lg={4} sm={12}>
                                    <div className={styles.card2}>
                                        <div className="d-flex justify-content-between">
                                            <div className={styles.cardText2}>Total Balance</div>
                                            <div className={styles.cardText4}>This Month</div>
                                        </div>
                                        <div className={styles.cardText3}>$4500</div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <div className={styles.heading}>All Payouts</div>
                    <div className='mt-3'>
                        <DynamicDatatable data={tableData} columns={columns} type={"gray"} />
                    </div>
                </>}
            {activeTab === "2" &&
                <PaymentOptions />
            }
        </LightGrayBgWrapper>
    )
}

export default CommissionAndPayout
